<template>
  <el-container class="checkLicense-container" data-mu-loading-color="primary"
    data-mu-loading-overlay-color="rgba(0, 0, 0, .7)" v-loading="loading">
    <div class="angleOfView flex" v-show="showAngleOfView">
      <left-header />
      <div class="set-content">
        <div class="init-qmc set-main">
          <div class="set-left">
            <img src="../../assets/img/jiaosexuanze.png" alt="" />
          </div>
          <div class="set-form flex_1">
            <h3 class="title">
              {{ $translate("selectRole") }}
            </h3>
            <el-form ref="form" label-width="80px" :status-icon="true">
              <el-form-item :label="$translate('userRoles')" style="text-align:left">
                <el-select ref="angleOfViewSelect" size="medium" v-model="currentRole" filterable
                  :placeholder="$translate('pSelectRole')">
                  <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="text-center">
          <el-button size="mini" type="danger" style="width:130px;margin-right: 80px;" @click="$router.go(-1)">
            {{ $translate("goBack") }}
          </el-button>
          <el-button type="primary" style="width:130px" size="mini" @click="changeRoles">
            {{ $translate("sure") }}
          </el-button>
        </div>
      </div>
    </div>
    <div v-if="noAuth" class="w_100 flex" style="background-color: #F4F5F7;">
      <overdue :no-auth-message="noAuthMessage" :no-user-type-message="noUserTypeMessage" />
    </div>
  </el-container>
</template>
<script>
import { CheckLicenseState } from "../../api/login.js";
import { decodeRedirectPath } from "../../utils/util";
import leftHeader from "../../components/leftHeader";
import overdue from "./component/overdue";

export default {
  /** 登录成功跳转的授权验证页面 */
  name: "CheckLicense",
  components: { leftHeader, overdue },
  data() {
    return {
      loading: false,
      showAngleOfView: false,
      roleOptions: [],
      currentRole: "",
      noAuth: false,
      noAuthMessage: "",
      noUserTypeMessage: "", //没有用户类型的提示
    };
  },
  mounted() {
    const _this = this;
    _this.loading = true;
    _this.noAuthMessage = "";
    if (
      localStorage.clientGlobalRole &&
      localStorage.clientGlobalRole !== "undefined"
    ) {
      _this.currentRole = +localStorage.clientGlobalRole;
    }

    CheckLicenseState().then(async (res) => {
      if (res) {
        if (res.isSuccess) {
          await _this.$store.dispatch("getCurrentUser");
          // if (res.message == '软件可用') {
          /**
           * angleOfView 为系统角色配置，分为单角色用户和多角色用户
           * 如果angleOfView为2就是多角色模式，当前登录完成验证后就需要选择角色
           * 设置全局变量angleOfView来监测当前系统是否需要多角色选择
           * 1.先进行授权验证，
           * 2.再进行角色配置检验是否为多角色模式
           * 3.再请求角色列表接口，如果角色只有一个则不进行选择
           * 4.验证完成正常跳转
           */

          _this.$api.SystemConfig.GetConfig().then((data) => {
            if (data && data.isSuccess) {
              _this.$store.commit("settingSystemConfig", data.data);
              if (data.data.angleOfView == 2) {
                _this.getRolesList();
              } else {
                _this.initGoto();
              }
            } else {
              _this.initGoto();
            }
          });
        } else {
          _this.noAuth = true;
          _this.noAuthMessage =
            (res && res.message) || _this.$translate("authorStatusAbnormal");
          _this.loading = false;
        }
      } else {
        _this.$store.commit("logout");
      }
    });
  },

  methods: {
    changeRoles() {
      this.$store.commit("setGlobalRole", this.currentRole);
      // 设置当前选中的全局角色配置
      this.initGoto();
    },
    getRolesList() {
      let _this = this;
      _this.loading = false;
      this.$api.Roles.GetRoleByUser().then((res) => {
        if (res && res.data) {
          _this.roleOptions = res.data || [];
          if (_this.roleOptions.length && _this.roleOptions.length > 1) {
            _this.showAngleOfView = true;
          }
          if (_this.roleOptions.length && _this.roleOptions.length == 1) {
            _this.$store.commit("setGlobalRole", _this.roleOptions[0].id);
            _this.initGoto();
            return;
          }
          setTimeout(() => {
            _this.$refs.angleOfViewSelect &&
              _this.$refs.angleOfViewSelect.focus();
          }, 500);
        } else {
          _this.$store.commit("setGlobalRole", "");
        }
      });
    },
    getUserConfig() {
      this.$api.UserLoginRedirectConfig.GetUserConfig().then((res) => {
        if (res && res.isSuccess) {
          let routeObj = { name: "home" };

          // if (this.$store.state.systemConfig.clientUIConfig && this.$store.state.systemConfig.clientUIConfig.find) {
          //   /**
          //    * 如果隐藏了发现菜单
          //  TODO: 添加配置文件后，隐藏这儿的判断，统一在路由拦截里添加
          //    */
          //   routeObj.name = "report"
          // }
          const { loginRedirectGoType } = res.data;
          switch (loginRedirectGoType) {
            case 1:
              //系统报表
              routeObj.name = "report";
              break;
            case 3:
              if (res.data.reportId && res.data.reportId != 0) {
                routeObj.name = "reportView";
                routeObj.params = { reportId: res.data.reportId };
              }
              break;
            case 2:
              routeObj.name = "customHome";
              break;
            default:
              break;
          }
          const { isEDC, isPortal, isBI } = this.$store.state;
          if (isEDC && !isPortal && !isBI) {
            routeObj.name = "mineTask";
          }
          this.$router.push(routeObj);
        } else {
          this.$router.push({ name: "home" });
        }
      });
    },
    initGoto() {
      /**
       * 添加登录后的第一个跳转，屏蔽一些没任何权限的设置跳转
       */
      const { isEDC, isBI, uiConfig, systemConfig, isShowPortal } =
        this.$store.state;
      const {
        personalData,
        findMenu,
        reportMenu,
        desginMenu,
        homeMenu,
        myMenu,
      } = uiConfig;

      //如果没有配置一个菜单
      const ifNoHasMenu =
        findMenu == "off" &&
        reportMenu == "off" &&
        desginMenu == "off" &&
        homeMenu == "off" &&
        myMenu == "off" &&
        !systemConfig.clientCustomMenuEnabled;
      //如果只有bi权限却没有配置BI菜单
      const isHasDesgin =
        !isEDC && isBI && !isShowPortal && desginMenu == "off";

      //如果没有任何用户类型
      const ifHasUserType = !isEDC && !isShowPortal && !isBI;
      //如果没有任何权限就自动退出到登录，如果没有配置任何菜单，也退回到登录,如果只有BI没有设计菜单权限也返回到登录
      const ifHasNoPortal =
        !isEDC &&
        isShowPortal &&
        !isBI &&
        findMenu == "off" &&
        homeMenu == "off" &&
        myMenu == "off" &&
        reportMenu == "off" &&
        !systemConfig.clientCustomMenuEnabled;
      //如果没有菜单权限的判断
      const ifHasShowNoAuth = isHasDesgin || ifNoHasMenu || ifHasNoPortal;

      if (ifHasUserType || ifHasShowNoAuth) {
        // 如果都没有权限跳到个人资料
        if (personalData !== "off") {
          this.$router.push({ name: "myInfo" });
        } else {
          this.noAuth = true;
          this.loading = false;
          this.noAuthMessage = "";
          this.noUserTypeMessage = ifHasShowNoAuth
            ? this.$translate("ifHasShowNoAuth")
            : this.$translate("ifHasUserType");
        }
        return;
      }
      const { isChange, redirect, path } = this.$route.query;
      if (isChange) {
        this.$router.push({
          name: "changePassword",
          params: { changeCode: isChange },
        });
        return;
      }
      if (redirect && !redirect.includes("/login")) {
        const redirectURL = decodeRedirectPath(redirect);
        if (redirectURL.startsWith("http")) {
          location = redirectURL;
        } else if (redirectURL.startsWith("/")) {
          const url = this.$getOrigin();

          location.href = url + "/#" + redirectURL;
        } else {
          this.$router.push(redirectURL);
        }
      } else if (path) {
        this.$router.push(path);
      } else {
        this.getUserConfig();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.set-content,
.angleOfView,
.checkLicense-container {
  background-color: #fff;
  height: 100%;
  width: 100%;
}
.set-main {
  width: 70%;
  max-width: 900px;
  min-height: 50%;
  margin: 0 auto;
  margin-top: 5%;
  margin-bottom: 5%;
  background: rgb(244, 244, 244);
  border-radius: 8px;
  display: flex;
}
.set-left,
.set-form {
  display: flex;
  justify-content: center;
  align-items: center;
}
.set-form {
  flex-direction: column;
}
.set-form .title {
  width: 100%;
  text-align: center;
  line-height: 2;
  margin-bottom: 3em;
}
.set-form .el-form {
  width: 70%;
}
.set-main > div {
  padding: 10px 5%;
}
.set-left {
  width: 30%;
  height: 50vh;
  border-right: 1px solid rgb(215, 225, 235);
  padding: 1em;
}
</style>
